import IPlan from "../../../../../model/interface/company/workload/IPlan";
import IEntry from "../../../../../model/interface/company/workload/IEntry";
import {Tag} from "antd";
import React from "react";
import IReport from "../../../../../model/interface/company/workload/IReport";
import LocaleText from "../../../settings/dictionary/LocaleText";

interface IProps {
    resource?: IPlan | IEntry | IReport
    waiting?: boolean
}

class PlanOrEntryOrReportState extends React.Component<IProps> {
    render() {
        const {resource, waiting} = this.props
        return (
            <>
                {resource ? {
                    'new': waiting ? <Tag className="text-capitalize" color={'yellow'}><LocaleText code={'company.workload.approval.state.waiting'} fallback={'Čeká na schválení'}/></Tag> : <Tag className="text-capitalize" color={'blue'}><LocaleText code={'company.workload.approval.state.new'} fallback={'Nový'}/></Tag>,
                    'waiting': <Tag className="text-capitalize" color={'yellow'}><LocaleText code={'company.workload.approval.state.waiting'} fallback={'Čeká na schválení'}/></Tag>,
                    'planned': <Tag className="text-capitalize" color={'blue'}><LocaleText code={'company.workload.approval.state.planned'} fallback={'Rozvrženo'}/></Tag>,
                    'approved': <Tag className="text-capitalize"
                                     color={'cyan'}>{'type' in resource ? (resource.type?.approvalRequired ? <LocaleText code={'company.workload.approval.state.approved'} fallback={'Schváleno'}/> : <LocaleText code={'company.workload.approval.state.set'} fallback={'Zadáno'}/>) : <LocaleText code={'company.workload.approval.state.approved'} fallback={'Schváleno'}/>}</Tag>,
                    'rejected': <Tag className="text-capitalize" color={'red'}><LocaleText code={'company.workload.approval.state.rejected'} fallback={'Zamítnuto'}/></Tag>,
                    'returned': <Tag className="text-capitalize" color={'orange'}><LocaleText code={'company.workload.approval.state.returned'} fallback={'Vráceno'}/></Tag>,
                    'spent': <Tag className="text-capitalize"><LocaleText code={'company.workload.approval.state.spent'} fallback={'Vyčerpáno'}/></Tag>,
                    'archived': <Tag className="text-capitalize" color={'purple'}><LocaleText code={'company.workload.approval.state.archived'} fallback={'Archivované'}/></Tag>,
                    'requestChange': <PlanOrEntryOrReportState resource={resource}/>
                }[resource.state] : <Tag className="text-capitalize"><LocaleText code={'company.workload.approval.state.new'} fallback={'Nový'}/></Tag>}
            </>
        )
    }
}

export default PlanOrEntryOrReportState